import { extend, localize } from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import fr from "vee-validate/dist/locale/fr.json";
import it from "vee-validate/dist/locale/it.json";
import de from "vee-validate/dist/locale/de.json";
import pt from "vee-validate/dist/locale/pt_PT.json";
import ro from "vee-validate/dist/locale/ro.json";
import es from "vee-validate/dist/locale/es.json";

import { setInteractionMode } from "vee-validate";
import { i18n } from "./i18n";
import {
    required,
    max,
    min,
    email,
    confirmed,
    min_value,
    max_value,
    numeric,
    length,
    image,
    size
} from "vee-validate/dist/rules";

extend("max", max);
extend("min", min);
extend("email", email);
extend("confirmed", confirmed);
extend("min_value", min_value);
extend("max_value", max_value);
extend("numeric", numeric);
extend("length", length);
extend("image", image);
extend("size", size);
extend("required", required);

const rootDictionnary = {
    en,
    fr,
    it,
    de,
    pt,
    ro,
    es
};

// Use custom rule for required price plan
extend("required_price_plan", {
    validate(value) {
        return {
            required: true,
            valid: ["", null, undefined].indexOf(value.plan) === -1
        };
    },
    computesRequired: true,
    message: () =>
        rootDictionnary[i18n.locale]["messages"]["required"].replace(
            "{_field_}",
            i18n.messages[i18n.locale].validation?.names?.plan ?? "plan"
        )
});

setInteractionMode("lazy");

localize(rootDictionnary);

localize({
    en: i18n.messages.en.validation,
    fr: i18n.messages.fr.validation,
    it: i18n.messages.it.validation,
    de: i18n.messages.de.validation,
    pt: i18n.messages.pt.validation,
    ro: i18n.messages.ro.validation,
    es: i18n.messages.es.validation
});

localize(i18n.locale);
